<script setup>
import { formApi } from '@/configs/forms-api';
import { useGlobalStore } from '@/stores/global';
defineProps({
  data: {
    type: Object,
    required: true,
    default: () => {},
  },
  template: {
    type: String,
    default: () => '',
  },
  icon: {
    type: String,
    default: () => '',
  },
  view: {
    type: String,
    default: 'dark',
    required: true,
    validator(value) {
      return ['dark', 'light'].includes(value);
    },
  },
  buttonsPrefixClass: { type: String, default: '' },
});
const globalStore = useGlobalStore();
function handleApplicationClick(type) {
  globalStore.setApplicationPopup({ visible: true, type });
}
</script>
<template>
  <ul
    v-if="data"
    :class="[
      'm-0 p-0 applications',
      template ? `applications--${template}` : '',
    ]"
  >
    <template v-for="(listItem, listItemIndex) in data" :key="listItemIndex">
      <li v-if="listItem.title" class="m-0 applications-item">
        <Button
          variant="text"
          class="applications-item-button button-icon-prev"
          :class="[
            `button-text-${view} ${buttonsPrefixClass}-${formApi[listItem.type]}`,
          ]"
          @click="handleApplicationClick(listItem.type)"
        >
          <CIcon
            class="button-icon-prev-icon"
            :name="icon === 'with-bg' ? 'arrow-bg' : 'arrow-red'"
            width="16"
            height="16"
          />
          {{ listItem.title }}
        </Button>
      </li>
    </template>
  </ul>
</template>

<style scoped lang="scss">
.applications {
  $parent: &;
  display: flex;
  flex-direction: column;
  list-style: none;
  &-item {
    margin-top: -8px;
    &:first-child {
      margin-top: 0;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(margin-top, -8);
      &:first-child {
        margin-top: 0;
      }
    }
  }
  &--support {
    #{$parent} {
      &-item {
        @include media-breakpoint-up(sm) {
          margin: -8px 0 0 0;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(margin-top, 8);
        }
      }
    }
  }
  &--hero {
    display: grid;
    grid-template-columns: 1fr;
    @include media-breakpoint-up(sm) {
      column-gap: 16px;
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      align-items: end;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(column-gap, 16);
    }
    #{$parent} {
      &-item {
        @include media-breakpoint-up(sm) {
          margin: -8px 0 0 0;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(margin-top, 8);
        }
      }
    }
  }
}
</style>
